<ul class="ant-timeline" [class.ant-timeline-pending]="dwPending">
  <ng-content></ng-content>
  <li *ngIf="dwPending" class="ant-timeline-item ant-timeline-item-pending">
    <div class="ant-timeline-item-tail"></div>
    <div class="ant-timeline-item-head ant-timeline-item-head-custom ant-timeline-item-head-blue">
      <i class="anticon anticon-spin anticon-loading"></i>
    </div>
    <div class="ant-timeline-item-content">
      <ng-container *ngIf="isPendingString; else pendingTemplate">{{ isPendingBoolean ? '' : dwPending }}</ng-container>
      <ng-template #pendingTemplate>
        <ng-template [ngTemplateOutlet]="dwPending"></ng-template>
      </ng-template>
    </div>
  </li>
</ul>